import { printHTML } from "hooks/utils/formatter";
import Categories from "components/Gutenberg/Categories/Categories";
import CallToActionBanner from "components/Gutenberg/CallToActionBanner/CallToActionBanner";
import Entrances from "components/Gutenberg/Entrances/Entrances";
import MostPopular from "components/Gutenberg/MostPopular/MostPopular";
import Projects from "components/Gutenberg/Projects/Projects";
import Slider from "components/Gutenberg/Slider/Slider";
import TextAndImage from "components/Gutenberg/TextAndImage/TextAndImage";
import Gallery from "components/Gutenberg/Gallery/Gallery";
import ContactForm from "components/Gutenberg/ContactForm/ContactForm";

const ComponentTraverser = ({ data, post_title, hide_title }) => {
  const has_children = data?.innerBlocks;

  const getComponentWithChildren = (type, is_first, children) => {
    switch (type) {
      case "nan/gallery":
        return <Gallery data={data} />;
      case "core/columns": {
        const has_custom_column_width = data?.innerBlocks?.some(
          (block) => block?.attrs?.width
        );

        const isStackedOnMobile =  data?.attrs?.isStackedOnMobile?.toString()?.length > 0 ? false : true;

        return (
          <div
            className={`columns last:mb-0 mb-6 gap-6 ${
              has_custom_column_width
                ? isStackedOnMobile
                  ? "flex flex-col md:flex-row"
                  : "flex flex-row"
                : isStackedOnMobile
                  ? "grid md:grid-flow-col md:auto-cols-fr"
                  : "grid grid-flow-col auto-cols-fr"
            }`}
          >
            {children}
          </div>
        );
      }
      case "core/column": {
        const parent_data = data?.parent_attrs;
        const isStackedOnMobile = parent_data?.isStackedOnMobile?.toString()?.length > 0 ? false : true;

        const style = {};
        if (data?.attrs?.width) {
          style.flexBasis = data?.attrs?.width;
        }

        return (
          <div
            className={`column ${
              isStackedOnMobile ? "" : "is-not-stacked-on-mobile"
            }`}
            style={style}
          >
            {children}
          </div>
        );
      }
      case "core/group":
        return <div className="group">{children}</div>;
      case "core/list": {
        const ListWrapper = data?.attrs?.ordered ? "ol" : "ul";

        return <ListWrapper>{children}</ListWrapper>;
      }
      case "core/container":
        return (
          <section className="px-4 mx-auto my-6 mb-10 lg:mb-16 max-w-app xl:px-0 md:mb-20 gutenberg-content">
            <div className="p-6 bg-white md:py-[5rem] rounded-10">
              <div className="max-w-3xl mx-auto">
                {is_first && !hide_title && post_title && <h1>{post_title}</h1>}
                {children}
              </div>
            </div>
          </section>
        );
      default:
        return <>{children}</>;
    }
  };

  const getComponentWithoutChildren = (type) => {
    if (!type) return null;
    switch (type) {
      case "acf/categories":
        return <Categories {...data} />;
      case "acf/call-to-action":
        return <CallToActionBanner {...data} />;
      case "acf/entrances":
        return <Entrances {...data} />;
      case "acf/most-popular":
        return <MostPopular {...data} />;
      case "acf/projects":
        return <Projects {...data} />;
      case "acf/slider":
        return <Slider {...data} />;
      case "acf/text-and-image":
        return <TextAndImage {...data} />;
      case "acf/contact-form":
        return <ContactForm data={data} />;
      default:
        return <>{printHTML(data?.innerHTML)}</>;
    }
  };

  if (!has_children) {
    return getComponentWithoutChildren(data?.blockName);
  }

  const children = has_children.map((item, index) => (
    <ComponentTraverser
      data={item}
      key={index}
    />
  ));

  return getComponentWithChildren(data?.blockName, data?.is_first, children);
};

export default ComponentTraverser;
